import React, { useState, useEffect } from "react";
// 1. Import useLocation alongside your existing router imports
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import HomePage from "./pages/HomePage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Apply from "./pages/Apply";
import Result from "./pages/Result";
import ResultPublic from "./pages/ResultPublic";
import Profile from "./pages/Profile";

import Callback from "./pages/Callback";

function App() {
  const navigate = useNavigate();
  // 2. Access the current location object
  const location = useLocation();

  const [isSignedIn, setIsSignedIn] = useState(!!localStorage.getItem("token"));
  const [user, setUser] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [bannerMessage, setBannerMessage] = useState("");

  // Helper boolean to check if current route is /results/public
  const isPublicResultPage = location.pathname === "/results/public";

  // Banner helper
  const triggerBanner = (message) => {
    setBannerMessage(message);
    setShowBanner(true);
    setTimeout(() => setShowBanner(false), 3000);
  };

  // Decode JWT
  const parseJwt = (token) => {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
      return JSON.parse(jsonPayload);
    } catch (e) {
      return null;
    }
  };

  // Load user from token/localStorage
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return handleLogout();

    const decoded = parseJwt(token);
    if (
      !decoded ||
      !decoded.exp ||
      decoded.exp < Math.floor(Date.now() / 1000)
    ) {
      return handleLogout();
    }

    const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setIsSignedIn(false);
    setUser(null);
  };

  const updateUser = (updatedUser) => {
    if (!updatedUser) return;
    setUser(updatedUser);
    localStorage.setItem("user", JSON.stringify(updatedUser));
  };

  const handleUserLogin = (status, userInfo) => {
    setIsSignedIn(status);
    if (status && userInfo) {
      updateUser(userInfo);
      triggerBanner(`✅ Welcome, Your account is active.`);
    }
  };

  return (
    <GoogleOAuthProvider clientId="YOUR_CLIENT_ID">
      <div className="App flex flex-col min-h-screen">
        {/* 3. Conditionally hide Header for /results/public */}
        {!isPublicResultPage && (
          <Header
            isSignedIn={isSignedIn}
            user={user}
            onUserLogin={handleUserLogin}
            onLogout={handleLogout}
          />
        )}

        {showBanner && (
          <div className="bg-green-100 text-green-700 p-3 text-center font-bold">
            {bannerMessage}
          </div>
        )}

        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/results" element={<Result />} />
            <Route path="/results/public" element={<ResultPublic />} />
            <Route path="/profile" element={<Profile />} />

            <Route
              path="/auth/esignet/callback"
              element={
                <Callback
                  onLogin={(userData) => handleUserLogin(true, userData)}
                />
              }
            />
          </Routes>
        </main>

        <Footer />
      </div>
    </GoogleOAuthProvider>
  );
}

export default App;
